import React from 'react';
import ReactDOM from 'react-dom';
import {SimpleCell, ButtonGroup, PanelHeader, Group, List, Title, Switch, Cell, Spinner, Badge} from '@vkontakte/vkui';
import {instanceOf} from 'prop-types';
import {Button, Accordion, Div, SplitLayout, SplitCol} from '@vkontakte/vkui';
import {
    Icon20Info,
    Icon28FolderOutline,
    Icon28ShoppingCartOutline,
    Icon16Phone,
    Icon16MailOutline,
    Icon28Video
} from "@vkontakte/icons";
import CartApi from "../api/CartApi";
import * as constants from "../assets/constants";
import {PartnersProductsApi} from "../api/PartnersProductsApi";
import {monitoring_items_key} from "../assets/constants";


class ParamsFilter extends React.Component {

    state = {
        items: [],
        loading: false,
        num_filters_show: 5,
        show_all: false
    }

    constructor(props) {
        super(props);
        window.addEventListener("message", this.receiveMessage, false)
        if (this.props.current_filter_items) {
            this.state.items = this.props.current_filter_items
        }
    }

    componentWillUnmount = () => {
        localStorage.setItem(monitoring_items_key, JSON.stringify(this.state.items_monitoring ? this.state.items_monitoring : {}))
        window.removeEventListener("message", this.receiveMessage)
    }

    receiveMessage = (event) => {
        // Загружаем параметры после того как товары загружены
        if (event.data == 'searchProductsLoaded' || event.data == 'paramsFilterReload') {
            this.getItems()
        }
    }
    applyFilters = () => {
        let filters = []
        const items = this.state.items

        this.state.items.map((el, index) => {
            let values = []
            el.values.map((val, indexValue) => {
                if (val.checked) {
                    values.push(val.id)
                }
            })
            if (values.length > 0) {
                filters.push({
                    param_id: el.id,
                    values: values
                });
            }
        })

        window.postMessage({type: "applyCurrentFilter", value: {filters, items}})
        if (this.props.from_modal) {
            window.postMessage("closeParamsFilterModal")
        }
    }
    cleanFilters = () => {
        let olds = this.state.items

        olds.map((el, index) => {
            el.hidden = false
            el.select = false
            el.values.map((val, indexValue) => {
                val.checked = false
                val.hidden = false
            })
        })
        this.setState({items: olds})
        setTimeout(() => this.applyFilters(), 700)
    }
    getItems = (isOnMount = false) => {
        clearInterval(this.changeInterval)
        let filters = []

        if (this.state.items) {
            this.state.items.map((el, index) => {
                let values = []
                el.values.map((val, indexValue) => {
                    if (val.checked) {
                        values.push(val.id)
                    }
                })
                if (values.length > 0) {
                    filters.push({
                        param_id: el.id,
                        values: values
                    });
                }
            })
        } else {
            filters = this.props.current_filter
        }
        this.setState({loading: true})

        const api = new PartnersProductsApi(this.props.base_url)
        api.getParamsList({
            group_id: this.props.current_group_id == null ? '' : this.props.current_group_id,
            params: filters,
        }).then((response) => {
            console.log(response.data)
            this.setState({loading: false})
            this.setState({num_filters_show: response.data.num_filters_show})
            if (filters.length > 0) {
                let olds = this.state.items
                let news = response.data.params

                olds.map((el, index) => {

                    let old = news.find((findEl) => findEl.id === el.id)
                    if (!old) {
                        let in_filter = filters.find((findV) => findV.param_id == el.id)
                        el.select = in_filter ? true : false
                        el.hidden = in_filter ? false : true
                        return

                    }

                    let find = false
                    let find_value = false
                    el.values.map((val, indexValue) => {
                        let oldV = old.values.find((findElV) => findElV.id === val.id)
                        if (!oldV) {
                            val.hidden = true
                            return
                        }
                        val.hidden = false
                        find = true

                    })

                    el.hidden = !find

                })
                this.setState({items: olds})
            } else {
                this.setState({items: response.data.params})
            }
        })
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.current_group_id !== this.props.current_group_id
            || prevProps.ffc_mode !== this.props.ffc_mode
            || prevProps.monitoring_mode !== this.props.monitoring_mode
        ) {
            this.setState({items: []})
            // Не вызываем getItems() здесь - ждём событие 'searchProductsLoaded' от MainCatalog
        }
    }

    componentDidMount() {
        // Если открыто в модальном окне (мобильная версия) - загружаем сразу,
        // т.к. событие 'searchProductsLoaded' уже было отправлено до открытия модалки
        if (this.props.from_modal) {
            this.getItems()
        }
        
        if (this.props.current_filter_items && this.props.current_filter_items.length > 0) {
            window.postMessage({type: "applyCurrentFilterItems", value: []})
        }
    }

    render() {
        let n = 0

        return (
            <SplitLayout>
                <SplitCol>
                    <Div>
                        <Title level="2" style={{marginBottom: 16}}>
                            Фильтры
                        </Title>
                        <ButtonGroup stretched>
                            <Button stretched loading={this.state.loading}
                                    onClick={() => this.applyFilters()}>Применить</Button>
                            <Button stretched mode="outline" onClick={() => this.cleanFilters()}>Сбросить</Button>
                        </ButtonGroup>
                    </Div>

                    <List>
                        {this.state.items.map((el, index) => {

                            if (!el.hidden) n++

                            return <Accordion key={'filter_item_' + el.id}
                                       style={{display: !this.state.show_all && n > this.state.num_filters_show || el.hidden ? 'none' : 'flex'}}>
                                <Accordion.Summary multiline indicator={el.select ?
                                    <Badge mode="prominent" aria-label="Новый раздел"/> : ''} className="param-name">
                                    <Title level="4" style={{marginBottom: 16}}>
                                        {el.name}
                                    </Title>
                                </Accordion.Summary>
                                <List style={{maxHeight: "200px", overflowY: 'auto', width: '100%',                                             zIndex: '7000',
                                    position: 'relative'}}>
                                    {el.values.map((val, indexValue) => (
                                        <SimpleCell Component="label" style={{
                                            fontSize: 'small',
                                            marginLeft: "5px",
                                            display: val.hidden ? 'none' : 'flex',

                                        }}
                                                    multiline key={'filter_item_' + el.id + '_value' + val.id}
                                                    after={<Switch
                                                        checked={val.checked}
                                                        onChange={(e) => this.setsValueChecked(e, index, indexValue)}/>}>
                                            {val.value}
                                        </SimpleCell>
                                    ))
                                    }
                                </List>
                            </Accordion>
                        })
                        }
                    </List>
                    {this.state.show_all ? '' :
                        <Div><Button stretched mode="outline" onClick={() => this.setState({show_all: true})}>Показать
                            все</Button></Div>}
                </SplitCol>
            </SplitLayout>
        )
    }

    changeInterval = null

    setsValueChecked = (e, index, indexValue) => {
        clearInterval(this.changeInterval)
        let olds = this.state.items
        let old = olds[index]
        old.values[indexValue].checked = e.target.checked
        olds[index] = old
        this.setState({items: olds})

        this.changeInterval = setInterval(() => {
            clearInterval(this.changeInterval)
            this.getItems()
        }, 1600)
    }
}

export default ParamsFilter